import React from "react";
import Modal from "../../../../components/elements/Modal";
import ManageCollectionTemplate from "../ManageCollectionTemplate";
import Drawer from "../../../../components/elements/Drawer";
import DrawerHeader from "../../../../components/elements/DrawerHeader";

const ManageCollectionTemplateModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    // <Modal
    //   isOpen={open}
    //   setIsOpen={close}
    //   size="xl2"
    //   title={data?._id ? "Update One" : "Create New"}
    // >
    //   <ManageCollectionTemplate
    //     getResponse={getResponse}
    //     close={close}
    //     data={data}
    //   />
    // </Modal>

    <Drawer
      open={open}
      onClose={(val) => {
        close(val);
      }}
      actualSize={"xl"}
      size={"xl"}
      title={data?._id ? "Update One" : "Create New"}
      subtitle="View, update and modify Collect Template details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      header={<DrawerHeader />}
    >
      <ManageCollectionTemplate
        getResponse={getResponse}
        close={close}
        data={data}
      />
    </Drawer>
  );
};

export default ManageCollectionTemplateModal;
